import React from 'react';
import Reflux from 'reflux';
import Header from '../sections/Header';
import Footer from '../sections/Footer';
import SuggestedUsers from '../sections/SuggestedUsers';
import SearchActions from '../actions/SearchActions';
import AppStore from '../AppStore';
import NotificationsStore from '../stores/NotificationsStore';
import NotificationsActions from '../actions/NotificationsActions';
import TopList from '../sections/TopList';
import history from '../history';
import CommentNotification from '../components/CommentNotification';
import FollowingNotification from '../components/FollowingNotification';
import WheelLoader from '../components/wheelloader/WheelLoader';
import RcIf, {RcElse} from 'rc-if';

class NotifPage extends Reflux.Component {
    constructor (props) {
        super(props);
        this.stores = [NotificationsStore, AppStore];
    }
    componentDidMount () {
        if (this.state.userLogged && this.state.user._id) {
            SearchActions.getUserSuggestions();
            NotificationsActions.getTopSuggestions();
            NotificationsActions.getNotifications(this.state.user._id);
        } else {
            history.push('/');
        }
    }

    notificationType = (notif) => {
        switch (notif.type) {
        case 'comment':
            return <CommentNotification key={notif._id} notification={notif} />;
        case 'following':
            return <FollowingNotification key={notif._id} notification={notif} />;
        default:
            return null;
        }
    }

    render () {
        return (
          <div>
            <Header />
            <main>
              <div className='row space-top searchHeader'>
                <div className='container-gral pad-nocat total_container_mobile'>
                  <div className='col l8 s12'>
                    <h4 className='title-home size-secondary-title'><span>Notificaciones</span></h4>
                    <div className='box-filter nopad_mobile'>
                      <RcIf if={(this.state.notifications && this.state.notifications.length > 0)}>
                        <ul className='notificacion-list'>
                          {
                                this.state.notifications.map((notif) => {
                                    return this.notificationType(notif);
                                })
                              }
                        </ul>
                        <RcElse>
                          <RcIf if={this.state.loadingNotifications}>
                            <WheelLoader />
                            <RcElse>
                              <div className='not-result-box'>
                                <img src='/images/icons/notfollow.svg' />
                                <h6>Aún no tiene notificaciones</h6>
                              </div>
                            </RcElse>
                          </RcIf>
                        </RcElse>
                      </RcIf>
                    </div>
                  </div>
                  <div className='col l4 s12'>
                    <div className='box-recomend'>
                      <h4 className='title-home size-secondary-title'>
                        <span>Tendencias</span>
                      </h4>
                      <div className='box-result full-boxes'>
                        <TopList tops={this.state.suggestedTops} />
                      </div>
                    </div>
                    <div className='box-recomend'>
                      <SuggestedUsers />
                    </div>
                  </div>
                </div>
              </div>
            </main>
            <Footer />
          </div>
        );
    };
}
export default NotifPage;



// WEBPACK FOOTER //
// ./src/pages/NotifPage.js